"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAINS_WITHOUT_MULTICALL = exports.multicallAbi = exports.MULTICALL_ADDRESS = exports.NATIVE_EVM_TOKEN_ADDRESS = exports.nativeTokenConstant = exports.uint256MaxValue = void 0;
exports.uint256MaxValue = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
exports.nativeTokenConstant = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
exports.NATIVE_EVM_TOKEN_ADDRESS = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
exports.MULTICALL_ADDRESS = "0xcA11bde05977b3631167028862bE2a173976CA11";
exports.multicallAbi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getEthBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
exports.CHAINS_WITHOUT_MULTICALL = [314, 3141]; // Filecoin, & Filecoin testnet
//# sourceMappingURL=index.js.map